import { render, staticRenderFns } from "./FileDetailsPopup.vue?vue&type=template&id=c957400c&scoped=true&"
import script from "./FileDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./FileDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./FileDetailsPopup.vue?vue&type=style&index=0&id=c957400c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c957400c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c957400c')) {
      api.createRecord('c957400c', component.options)
    } else {
      api.reload('c957400c', component.options)
    }
    module.hot.accept("./FileDetailsPopup.vue?vue&type=template&id=c957400c&scoped=true&", function () {
      api.rerender('c957400c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileExplorer/FileDetailsPopup.vue"
export default component.exports